import { TimePicker } from 'antd';
import SyringeRegularIcon from '../../../../../../../../../icons/regular/syringe-regular';
import TrashRegularIcon from '../../../../../../../../../icons/regular/trash-regular';
import PopoverHeader from '../../../../../../../../common/PopoverHeader';
import PlusSolidIcon from '../../../../../../../../../icons/solid/plus-solid';
import { TSplitTiming } from '../InjectionFrequency';
import moment from 'moment';
import { DoseSearchComponent } from '../InjectionDose';
import { INJECTION_COLUMN } from '../../../../../../../../../utils/enums';
import { InjectionsEntity } from '../../../../../../../../../store/types/prescription';

const FrequencyDoseTimePopup = ({
    onClose,
    timeSplit,
    onSplitChange,
    element,
}: {
    onClose: () => void;
    timeSplit: TSplitTiming[];
    onSplitChange: (timingSplit: TSplitTiming[]) => void;
    element: InjectionsEntity;
}): JSX.Element => {
    const handleTimeChange = (value: Date | string, index: number) => {
        const clonedSplit = [...timeSplit];
        clonedSplit[index].timing = value;
        onSplitChange(clonedSplit);
    };

    const handleQuantityChange = (value: string, index: number) => {
        const clonedSplit = [...timeSplit];
        clonedSplit[index].quantity = value;
        onSplitChange(clonedSplit);
    };

    return (
        <>
            <PopoverHeader title={'Add frequency & dose time'} onClose={onClose} />
            <div className="py-12 px-16 flex flex-col space-y-8">
                {timeSplit.map((split, index) => (
                    <div
                        className="flex flex-row justify-between items-center space-x-8"
                        key={`time-split-${index}`}
                    >
                        <SyringeRegularIcon className="text-darwin-neutral-600 w-16 h-16" />
                        <TimePicker
                            onSelect={(value) => {
                                handleTimeChange(new Date(moment(value).toDate()), index);
                            }}
                            use12Hours={true}
                            format={'hh:mm A'}
                            minuteStep={15}
                            value={split.timing ? moment(new Date(split.timing), 'hh:mm A') : null}
                            popupClassName="noFooterTimePick"
                        />

                        <DoseSearchComponent
                            columnKey={INJECTION_COLUMN.DOSE}
                            defaultValue={split.quantity || ''}
                            onDoseSelect={(option) =>
                                handleQuantityChange(option?.label as string, index)
                            }
                            selectedValue={{
                                id: split.quantity || '',
                                label: split.quantity || '',
                                value: split.quantity || '',
                                meta: {
                                    unit: split.quantity,
                                    id: split.quantity,
                                },
                            }}
                            allowEdit={false}
                            placeholder="1 unit"
                            element={element}
                        />
                        <button
                            className="cursor-pointer"
                            onClick={() => {
                                const splitForRemoval = [...timeSplit];
                                splitForRemoval.splice(index, 1);
                                onSplitChange(splitForRemoval);
                            }}
                        >
                            <TrashRegularIcon className="text-darwin-neutral-600 w-14 h-14" />
                        </button>
                    </div>
                ))}
                <div className="inline">
                    <button
                        className="text-13 font-700 flex flex-row items-center space-x-10 text-actionPrimary cursor-pointer"
                        onClick={() => {
                            let addOnList: TSplitTiming[] = [];
                            if (timeSplit && timeSplit.length > 0) {
                                addOnList = [...addOnList, ...timeSplit];
                            }
                            addOnList = [
                                ...addOnList,
                                { id: addOnList.length, quantity: '', timing: '' },
                            ];
                            onSplitChange(addOnList);
                        }}
                    >
                        <PlusSolidIcon className="w-14 h-14" />
                        Add
                    </button>
                </div>
            </div>
            <style>
                {`
                    .noFooterTimePick .ant-picker-footer{
                        display: none;
                    }
                `}
            </style>
        </>
    );
};

export default FrequencyDoseTimePopup;
